import { render } from "./RegisterPartner.vue?vue&type=template&id=68996db8&scoped=true"
import script from "./RegisterPartner.vue?vue&type=script&lang=js"
export * from "./RegisterPartner.vue?vue&type=script&lang=js"

import "@/assets/css/layout_registerPartner.css?vue&type=style&index=0&id=68996db8&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68996db8"]])

export default __exports__